import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityRolAdapter, EntityRolState } from './entity-roles.state';
import { selectAuthPersona } from '../../persona/entity-personas/entity-personas.selectors';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { EntidadesProductiva } from '../../empresas/entity-entidad-productiva/entity-entidades-productiva.model';

const { selectEntities, selectAll } = entityRolAdapter.getSelectors();

export const getError = (state: EntityRolState): any => state.error;

export const getIsLoading = (state: EntityRolState): boolean => state.isLoading;

export const selectRolState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.roles
);

export const selectAllRol = createSelector(selectRolState, selectAll);
export const selectEntitiesRol = createSelector(selectRolState, selectEntities);

export const selectRolesPropios = createSelector(
  selectAllRol,
  selectAuthPersona,
  (roles, p) => roles.filter((r) => r.persona_id == p.id)
);

// MemoizedSelector<object,any>
export const selectRolError = createSelector(selectRolState, getError);

// MemoizedSelector<object,any>
export const selectRolIsLoading = createSelector(selectRolState, getIsLoading);

export const selectRolesPropiosByEntidadProductivaId = (
  entidadProductivaId: number
) => {
  return createSelector(selectRolesPropios, (roles) =>
    roles.filter((r) => r.entidad_productiva_id === entidadProductivaId)
  );
};

export const selectRolesPropiosByCurrentEntidadProductiva = createSelector(
  selectCurrentEmpresa,
  selectRolesPropios,
  (currentEmpresa, roles) => {
    if (currentEmpresa && currentEmpresa.id) {
      return roles.filter((r) => r.entidad_productiva_id === currentEmpresa?.id);
    } else {
      return [];
    }
  }
);

export const selectAllRolesByCurrentEmpresa = createSelector(
  selectCurrentEmpresa,
  selectAllRol,
  (currentEmpresa, roles) => {
    if (currentEmpresa && currentEmpresa.id) {
      return roles.filter((r) => r.entidad_productiva_id === currentEmpresa.id);
    } else {
      return [];
    }
  }
);
